export default __webpack_public_path__ + "static/chat-929f6322d6c4b2fa708a20cd1933ce31.png";